<div class="browser-container">
    <div class="browser-header">
        <h4 class="browser-title">
            <i class="fas fa-search me-2"></i>
            Browser Template-uri cu Categorii
        </h4>
    </div>

    <div class="browser-body">
        <!-- Statistics Bar -->
        <div class="statistics-bar mb-3" *ngIf="statistics && Object.keys(statistics).length > 0">
            <div class="d-flex justify-content-between align-items-center">
                <div class="stats-info">
                    <span class="stat-item">
                        <i class="fas fa-file-alt text-primary me-1"></i>
                        <strong>{{ statistics.total_document_templates || 0 }}</strong> &nbsp;Oficiale
                    </span>
                    <span class="stat-item ms-3">
                        <i class="fas fa-file-text text-secondary me-1"></i>
                        <strong>{{ statistics.total_request_templates || 0 }}</strong> &nbsp;Cereri
                    </span>
                    <span class="stat-item ms-3">
                        <i class="fas fa-exclamation-triangle text-warning me-1"></i>
                        <strong>{{ statistics.uncategorized_templates || 0 }}</strong> &nbsp;Necategorizate
                    </span>
                </div>
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="refreshData()"
                    [disabled]="isLoading">
                    <i class="fas fa-sync-alt me-1" [class.fa-spin]="isLoading"></i>
                    Reîmprospătează
                </button>
            </div>
        </div>

        <div class="browser-content">
            <!-- Sidebar with Categories -->
            <div class="sidebar">
                <div class="sidebar-header">
                    <h6 class="mb-0">
                        <i class="fas fa-sitemap me-1"></i>
                        Categorii
                    </h6>
                </div>

                <div class="sidebar-content">
                    <!-- View Mode Buttons -->
                    <div class="view-modes mb-3">
                        <button type="button" class="btn btn-sm w-100 mb-1"
                            [class.btn-primary]="viewMode === 'all' && !showUncategorized"
                            [class.btn-outline-primary]="viewMode !== 'all' || showUncategorized"
                            (click)="onViewModeChange('all')">
                            <i class="fas fa-list me-1"></i>
                            Toate Template-urile
                        </button>
                        <button type="button" class="btn btn-sm w-100" [class.btn-warning]="showUncategorized"
                            [class.btn-outline-warning]="!showUncategorized" (click)="showUncategorizedTemplates()">
                            <i class="fas fa-exclamation-triangle me-1"></i>
                            Necategorizate
                        </button>
                    </div>

                    <!-- Category Tree -->
                    <div class="category-tree" *ngIf="categoryTree.length > 0">
                        <app-template-category-tree [treeData]="categoryTree" [allowSelection]="true"
                            [allowMultiSelection]="false" [showTemplateCount]="true" [showActions]="false"
                            [selectedCategoryIds]="selectedCategory ? [selectedCategory.id] : []"
                            (categorySelected)="onCategorySelected($event)">
                        </app-template-category-tree>
                    </div>

                    <div *ngIf="categoryTree.length === 0" class="text-center py-3 text-muted">
                        <i class="fas fa-folder-open fa-2x mb-2"></i>
                        <p class="small">Nu există categorii</p>
                    </div>
                </div>
            </div>

            <!-- Main Content -->
            <div class="main-content">
                <!-- Filters and Search -->
                <div class="filters-section mb-3">
                    <form [formGroup]="filterForm">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <div class="input-group">
                                    <span class="input-group-text">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    <input type="text" class="form-control" formControlName="search"
                                        placeholder="Căutați template-uri...">
                                </div>
                            </div>
                            <div class="col-md-3">
                                <select class="form-select" formControlName="template_type">
                                    <option *ngFor="let type of templateTypes" [value]="type.value">
                                        {{ type.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <select class="form-select" formControlName="status">
                                    <option value="">Toate statusurile</option>
                                    <option value="active">Doar active</option>
                                    <option value="inactive">Doar inactive</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- Content Header -->
                <div class="content-header mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="view-info">
                            <h6 class="mb-0">{{ getViewTitle() }}</h6>
                            <small class="text-muted">
                                {{ getFilteredCount() }} din {{ getTotalCount() }} template-uri
                            </small>
                        </div>
                        <div class="selected-category-info" *ngIf="selectedCategory">
                            <div class="badge bg-primary">
                                <i class="fas fa-tag me-1"></i>
                                {{ selectedCategory.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Loading State -->
                <div *ngIf="isLoading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Se încarcă...</span>
                    </div>
                    <p class="mt-2 text-muted">Se încarcă template-urile...</p>
                </div>

                <!-- Templates List -->
                <div class="templates-list" *ngIf="!isLoading">
                    <div *ngFor="let template of filteredTemplates; trackBy: trackByTemplate" class="template-card"
                        [class]="getTemplateStatusClass(template)">

                        <div class="template-header">
                            <div class="template-info">
                                <div class="template-icon">
                                    <mat-icon>{{ getTemplateTypeIcon(template.type) }}</mat-icon>
                                </div>
                                <div class="template-details">
                                    <h6 class="template-name">{{ template.name }}</h6>
                                    <div class="template-meta">
                                        <span class="badge" [class.badge-primary]="template.type === 'oficial'"
                                            [class.badge-secondary]="template.type === 'cerere'">
                                            {{ getTemplateTypeLabel(template.type) }}
                                        </span>
                                        <span class="badge ms-1" [class.badge-success]="template.active"
                                            [class.badge-danger]="!template.active">
                                            {{ template.active ? 'Activ' : 'Inactiv' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="template-actions">
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="openCategoryAssignmentDialog(template)" title="Gestionează categorii">
                                    <i class="fas fa-tags me-1"></i>
                                    Categorii
                                </button>
                            </div>
                        </div>

                        <div class="template-body">
                            <div class="categories-info">
                                <div class="categories-label">
                                    <i class="fas fa-tags me-1"></i>
                                    Categorii:
                                </div>
                                <div class="categories-display">
                                    <span
                                        [class.text-muted]="template.categories.length === 0 && !template.primary_category">
                                        {{ getCategoriesDisplay(template) }}
                                    </span>
                                </div>
                            </div>

                            <!-- Category Details -->
                            <div class="category-details"
                                *ngIf="template.categories.length > 0 || template.primary_category">

                                <!-- Primary Category -->
                                <div class="primary-category mb-2" *ngIf="template.primary_category">
                                    <div class="category-badge primary">
                                        <i class="fas fa-star me-1"></i>
                                        <strong>{{ template.primary_category.name }}</strong>
                                        <span class="category-type">Primară</span>
                                    </div>
                                </div>

                                <!-- Additional Categories -->
                                <div class="additional-categories" *ngIf="template.categories.length > 0">
                                    <div class="category-badges">
                                        <div *ngFor="let category of template.categories; trackBy: trackByCategory"
                                            class="category-badge"
                                            [class.d-none]="template.primary_category && category.id === template.primary_category.id">
                                            <i class="fas fa-tag me-1"></i>
                                            {{ category.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Organization Info -->
                            <div class="organization-info" *ngIf="template.directie_info || template.compartiment_info">
                                <small class="text-info">
                                    <i class="fas fa-building me-1"></i>
                                    {{ template.directie_info?.name }}
                                    <span *ngIf="template.compartiment_info"> - {{ template.compartiment_info.name
                                        }}</span>
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="filteredTemplates.length === 0" class="empty-state text-center py-5">
                        <i class="fas fa-search fa-3x text-muted mb-3"></i>
                        <h6 class="text-muted">Nu au fost găsite template-uri</h6>
                        <p class="text-muted">
                            <span *ngIf="filterForm.get('search')?.value">
                                Încercați să modificați criteriile de căutare.
                            </span>
                            <span *ngIf="!filterForm.get('search')?.value && selectedCategory">
                                Această categorie nu conține template-uri.
                            </span>
                            <span *ngIf="!filterForm.get('search')?.value && !selectedCategory && showUncategorized">
                                Nu există template-uri necategorizate.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="browser-footer">
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-secondary" (click)="onClose()">
                <i class="fas fa-times me-1"></i>
                Închide
            </button>
        </div>
    </div>
</div>